import { render, staticRenderFns } from "./UpgradeFeatureDetail.vue?vue&type=template&id=18033c9e&scoped=true"
import script from "./UpgradeFeatureDetail.vue?vue&type=script&lang=js"
export * from "./UpgradeFeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFeatureDetail.vue?vue&type=style&index=0&id=18033c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18033c9e",
  null
  
)

export default component.exports